"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const OsmosysForm_1 = require("../../..");
const utils_1 = require("@osmosys/utils");
const react_use_1 = require("react-use");
const react_2 = require("@osmosys/react");
exports.OsmosysFormSlugField = ({ placeholder = 'Slug', autoInput, autoInputEnabled, autoInputName, name, }) => {
    const { data, onFieldChange } = OsmosysForm_1.useOsmosysForm();
    const [hasControl, toggleControl] = react_use_1.useToggle(false);
    const ref = react_1.useRef(null);
    const value = data[name];
    const autoInputValue = autoInputEnabled
        ? autoInputName
            ? data[autoInputName]
            : autoInput
        : false;
    const onChange = react_1.useCallback((newValue, force = false) => {
        if (typeof newValue === 'string') {
            onFieldChange(name, !force &&
                document.activeElement &&
                document.activeElement.isSameNode(ref.current)
                ? newValue
                : utils_1.osmosysSlugify(newValue));
        }
        else {
            console.error(`${newValue} is not a string`);
        }
    }, [onFieldChange, name]);
    react_use_1.useDebounce(() => {
        if (hasControl) {
            onChange(value, true);
        }
    }, 10 * 1000, [hasControl, value]);
    react_1.useEffect(() => {
        if (!hasControl && autoInputEnabled) {
            onChange(autoInputValue);
        }
    }, [hasControl, autoInputEnabled, autoInputValue]);
    return (react_1.default.createElement(reactstrap_1.InputGroup, null,
        react_1.default.createElement(reactstrap_1.Input, { innerRef: ref, readOnly: !hasControl, onDoubleClick: () => {
                toggleControl(true);
            }, onBlur: e => {
                onChange(e.target.value);
            }, placeholder: placeholder === false ? undefined : placeholder, value: value, onChange: e => {
                onChange(e.target.value);
            } }),
        react_1.default.createElement(react_2.OsmosysButtonAddon, { addonType: "append", osysName: "OsmosysSlugControl", color: "link", toggledIcon: hasControl, onClick: toggleControl, tooltip: hasControl ? 'Change to automatic slug' : 'Change to manual slug' })));
};
//# sourceMappingURL=OsmosysFormSlugField.js.map